import React from "react";
import PageHeader from "../../PageHeader";
import { ReactComponent as SubjectIcon } from "../../../images/subjectimage/subjecticon.svg";
import { ReactComponent as AddIcon } from "../../../images/pageheadingicon/addicon.svg";
import useStyles from "../../../../styles";
import ViewAllocatedApprovedStudent from "./ViewAllocatedApprovedStudent";


function AllocatedApprovedStudent() {
  const classes = useStyles();
  const Heading = [
    {
      id: 1,
      pageicon:<SubjectIcon />,
      mainheading: "Approved Student",
      // subhead: "Want to Add in Bulk ? ?",
      // downloadlink: "Download bulk Sample Files",
      // addbtntext:"Allocate New Center",
      // addbtnicon: <AddIcon />,
      // addbtnstyle: "bluebtn",
      path:"/admin/addallocatedcenter",
    },
  ];
  return (
    <div className={`${classes.p1} ${classes.pb0}`}>
      <PageHeader Heading={Heading}/>
      <ViewAllocatedApprovedStudent/>
    
    </div>
  );
}
export default AllocatedApprovedStudent;